import {
  TypographyBlockquote,
  TypographyDescription,
  TypographyFirm,
  TypographyH1,
  TypographyH2,
  TypographyH3,
  TypographyH4,
  TypographyLarge,
  TypographyP,
  TypographySmall,
} from "./parts";

const Typography = {
  Blockquote: TypographyBlockquote,
  Description: TypographyDescription,
  Firm: TypographyFirm,
  H1: TypographyH1,
  H2: TypographyH2,
  H3: TypographyH3,
  H4: TypographyH4,
  Large: TypographyLarge,
  P: TypographyP,
  Small: TypographySmall,
};

export default Typography;
